import gql from 'graphql-tag';
import { useMutation } from '@apollo/client';

const MUTATION = gql`
  mutation fullRefundSoftwareOrder($orderNumber: String!) {
    refundOrder: fullRefundSoftwareOrder(orderNumber: $orderNumber) {
      id
      orderNumber
      status {
        statusCode
        title
        description
      }
    }
  }
`;

function useRefundSoftwareOrder(
  onCompleted: (data: any) => void,
  onError: (error: any) => void
) {
  const [action] = useMutation(MUTATION, {
    refetchQueries: ['getOrder'],
    onCompleted,
    onError,
  });

  return (orderNumber: string) => {
    return action({ variables: { orderNumber } });
  };
}

export default useRefundSoftwareOrder;
